import { useMutation } from 'react-query';

import { deleteForumPost } from '../utils/backend-api/forumPosts';

export default function useForumPostDelete() {
  const { mutate, isLoading, isError } = useMutation((id: number) => deleteForumPost(id));
  return { mutate, isLoading, isError };
}
